import styled, { css } from "styled-components";

import * as Grid from "@ui/Atoms/Grid";

import { RootProps } from "./Section.types";

export const Root = styled.section<RootProps>`
  --lp-section-color: ${props => props.theme.palette.grey800};
  --lp-section-bg-color: ${props => props.$bgColor};

  ${props =>
    props.$isDarkMode &&
    css`
      --lp-section-color: ${props => props.theme.palette.white};
    `}

  padding-top: ${props => props.theme.spacing.spacing_64};
  padding-bottom: ${props => props.theme.spacing.spacing_64};
  color: var(--lp-section-color);
  background-color: var(--lp-section-bg-color);

  ${props => props.theme.breakpoints.desktop} {
    padding-top: ${props => props.theme.spacing.spacing_80};
    padding-bottom: ${props => props.theme.spacing.spacing_80};
  }
`;

export const Description = styled(Grid.Row)`
  margin-top: ${props => props.theme.spacing.spacing_8};
`;

export const Body = styled(Grid.Row)`
  margin-top: ${props => props.theme.spacing.spacing_32};
`;
